import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Axios from "axios";
import { __values } from "tslib";

Vue.config.productionTip = false;

Vue.filter("truncate", function(val: string, len?: number) {
  if (!val || val.length <= (len || 80)) return val;
  return val.substring(0, len || 80) + " ...";
});

Axios.interceptors.request.use(config => {
  let { headers } = { ...config };
  if (store.state.session.token) {
    headers = { Authorization: "Bearer " + store.state.session.token };
  }
  return { ...config, headers };
});

new Vue({
  store: store.original,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
